import { __assign, __rest } from "tslib";
import React from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import NoScript from '../NoScript';
import { useLazyLoading } from './useLazyLoading';
var LazyLoadingImage = function (_a) {
    var children = _a.children, innerRef = _a.innerRef, props = __rest(_a, ["children", "innerRef"]);
    var _b = useLazyLoading(), enableLazyLoading = _b.enableLazyLoading, supportsNativeLazy = _b.supportsNativeLazy, ref = _b.ref, inView = _b.inView;
    var isMounted = useIsMounted();
    if (!enableLazyLoading || supportsNativeLazy) {
        return React.createElement("img", __assign({ alt: "", loading: "lazy", ref: innerRef }, props));
    }
    return (React.createElement(React.Fragment, null,
        !isMounted && (React.createElement(NoScript, null,
            React.createElement("img", __assign({ alt: "" }, props)))),
        React.createElement("div", { ref: ref }, inView ? (React.createElement("img", __assign({ ref: function (node) {
                innerRef && innerRef(node);
            }, alt: "", loading: "lazy" }, props))) : (React.createElement("svg", { width: props.width, height: props.height, style: props.style, "data-hook": props['data-hook'] })))));
};
LazyLoadingImage.displayName = 'LazyLoadingImage';
export default React.memo(LazyLoadingImage);
//# sourceMappingURL=LazyLoadingImage.js.map